function version(str) {
  return parseInt(str.trim()) || 0;
}

module.exports = version;
